module.exports = __webpack_public_path__ + "assets/Other.e7fcb201802e2d6ffa9d99e28badd8e7.png";